import { Link } from "react-router-dom";

// Official Central Rentals Canada logo — dark skyline + wordmark on a
// transparent background (processed from the client-supplied artwork).
export const BRAND_LOGO_URL = "/brand-logo.png";

/**
 * Legacy graphical mark removed at the owner's request. Adjacent text
 * wordmarks remain in the sidebar, mobile header and role selection page.
 */
export function BrandMark() {
  return null;
}

/**
 * FullBrandLogo — bold text wordmark used across the public header +
 * landing. Renders "Central Rentals Canada" as a big bold headline
 * with a smaller "PM Software" caption underneath — no image, so the
 * brand is legible on every viewport width without waiting for an
 * asset to download. `height` is retained as a prop for backward
 * compatibility with existing call sites but now drives the font
 * size instead of an image height.
 */
export function FullBrandLogo({ to = "/", height = 48, testid = "public-logo" }) {
  const bigPx = Math.max(22, Math.round(height * 0.42));
  const smallPx = Math.max(11, Math.round(height * 0.22));
  return (
    <Link
      to={to}
      data-testid={testid}
      className="inline-flex flex-col items-start select-none whitespace-nowrap"
      aria-label="Central Rentals Canada — PM Software"
    >
      <span
        className="font-display font-black tracking-tight text-slate-900 leading-none"
        style={{ fontSize: `clamp(18px, 2.6vw, ${bigPx}px)` }}
      >
        Central Rentals Canada
      </span>
      <span
        className="font-display font-bold tracking-[0.08em] uppercase text-emerald-700 leading-none mt-1"
        style={{ fontSize: `clamp(10px, 1.1vw, ${smallPx}px)`, letterSpacing: "0.14em" }}
      >
        PM Software
      </span>
    </Link>
  );
}

/**
 * BrandLockup — mark + wordmark combo. Retained for the app sidebar.
 */
export function BrandLockup({ to = "/", size = 40, light = false, testid = "brand-lockup" }) {
  return (
    <Link to={to} className="flex items-center gap-2.5" data-testid={testid}>
      <BrandMark size={Math.max(size, 48)} float />
      <div className="leading-tight">
        <div className={`font-display font-bold text-lg ${light ? "text-slate-900" : "text-white"}`}>Central Rentals</div>
        <div className={`text-xs tracking-[0.22em] uppercase font-semibold ${light ? "text-slate-500" : "text-white/70"}`}>Canada</div>
      </div>
    </Link>
  );
}
